import React, { useState, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './app/ProtectedRoute';
// import { Login } from './features/auth/Login';
import StyledToastContainer from './app/components/styledComponents/StyledToastContainer';
import LoginByCognito from './features/auth/LoginByCognito';
import { Logout } from './features/auth/Logout';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { routesWithMeta } from './utils/meta';
import find from 'lodash/find';
import { Container } from 'react-bootstrap';
import { MidleWare } from './midleware/midleware';
import OutlookComponent from './features/Setting/AccountCalender/OutlookComponent';
import GoogleCalendar from './features/Setting/AccountCalender/GoogleCalendarComponent';
import { ClearStorage } from './features/auth/ClearStorage';
import { isPublicPage, useWindowSize } from './utils/helper';
import { USERROLES } from './features/users/creation/assets/utills';
import {
  getForceLoginPermissionState,
  setForceLoginPermission,
  setOOOPermission,
} from './midleware/permisssionReducer';
import LimitedPermissionModal from './utils/LimitedPermissionModal';
import PermissionDeniedModal from './permission-system/modals/PermissionDeniedModal';
import { useDispatch, useSelector } from 'react-redux';
import usePermission from './hooks/usePermission';
import PublicPagesTheme from './midleware/PublicPagesTheme';
import OutlookComponentLogin from './features/auth/OutlookComponentLogin';
import GoogleComponentLogin from './features/auth/GoogleComponentLogin';
import { ForceLogin } from './features/auth/Forcelogin';
import ReleaseChannelBadge from './app/components/ReleaseChannelBadge';

import ProfileVideo from './features/WebRtc/ProfileVideo';
import ProfileVideoJobDetails from './features/WebRtc/ProfileVideoJobDetails';
import ReportingRoutes from './features/Reporting/ReportingRoutes';
import AnalyticsDashboard from './features/analytics/analyticsDashboard/AnalyticsDashboard';
const AddReferee = lazy(() =>
  import( './features/ReferenceChecks/AddReferee'))
const AddRefereeForm = lazy(() =>
  import('./features/ReferenceChecks/AddRefereeForm')
);
// import { ChurnZeroScript } from './midleware/ChurnZeroTracking';
const LoginForm = lazy(() => import('./features/auth/LoginForm'));
const ViewAllNotifications = lazy(() =>
  import('./features/Setting/Notifications/components/ViewAllNotifications'),
);
const DelegetedUserLogin = lazy(() =>
  import('./features/dashboard/listing/DelegatedUserLogin'),
);
const WelcomePage = lazy(() => import('./features/occyWelcome/WelcomePage'));
const SearchPublicPage = lazy(() =>
  import('./features/careerPage/SearchPublicPage'),
);
const CareerPublicPreview = lazy(() =>
  import('./features/careerPage/CareerPublicPreview'),
);
const RestrictedAccess = lazy(() => import('./midleware/RestrictedAccess'));
const PolicyContainer = lazy(() =>
  import('./features/termsAndConditions/Privacy&Policy'),
);
const PrivacyPolicyContainer = lazy(() =>
  import('./features/termsAndConditions/components/PrivacyPolicyContainer'),
);
const KanbanOfferLetterContainer = lazy(() =>
  import('./features/kanban/CandidateOffer/KanbanOfferLetterContainer'),
);
const OfferLetter = lazy(() =>
  import('./features/kanban/CandidateOffer/OfferLetter'),
);
const DocumentContainer = lazy(() =>
  import('./features/kanban/ApplicationDetails/SendDocument/DocumentContainer'),
);
const JobOfferContainer = lazy(() =>
  import('./features/kanban/CandidateOffer/JobOfferContainer'),
);
const ComponentsList = lazy(() =>
  import('./features/componentsLibrary/ComponentsList'),
);
const FormPreview = lazy(() =>
  import('./features/forms/formPreview/FormPreview'),
);
const CandidateSelfSchedule = lazy(() =>
  import('./features/ReInterviews/components/CandidateSelfSchedule'),
);
const NonPresignedOfferContainer = lazy(() =>
  import('./features/kanban/CandidateOffer/NonPresignedOfferContainer'),
);
const UnsubscribeContainer = lazy(() =>
  import('./features/termsAndConditions/Unsubscription'),
);
const PublicFormContainer = lazy(() =>
  import('./features/forms/formPublic/PublicFormContainer'),
);
const DashboardContainer = lazy(() =>
  import('./features/dashboard/listing/DashboardContainer'),
);
const Alerts = lazy(() => import('./features/Setting/Alerts'));
const UserRoutes = lazy(() => import('./features/users/userRoutes'));
const CampaignRoutes = lazy(() =>
  import('./features/campaigns/CampaignRoutes'),
);
// const CopyrightListing = lazy(() => import('./features/copyright/CopyrightListing'));

// const RecruitersRoutes = lazy(() => import('./features/recruitersSlots/recruitersRoutes'));
const JobRoutes = lazy(() => import('./features/job/JobRoutes'));
const PipelineAutomation = lazy(() =>
  import('./features/Automation/PipelineAutomation'),
);
const WizardRoutes = lazy(() =>
  import('./features/dashboard/listing/WizardRoutes'),
);
const CalenderView = lazy(() => import('./features/calender/calenderView'));
// const CopywriteDetailView = lazy(() => import('./features/copyright/CopywriteDetailView'));
const CareerPageContainer = lazy(() =>
  import('./features/CreateCareerPage/CareerPageContainer'),
);
const MailRoutes = lazy(() => import('./features/mailbox/mailRoutes'));
const CandidateRoutes = lazy(() =>
  import('./features/candidates/candidateRoutes'),
);

const AuthorityToRecruitRoutes = lazy(() =>
  import('./features/AuthorityToRecruit/AuthorityToRecruitRoutes'),
);
const OffersRoutes = lazy(() =>
  import('./features/OffersAndAgreements/OffersRoutes'),
);
const SignablePreview = lazy(() =>
  import('./features/kanban/CandidateOffer/SignablePreview'),
);
const TransferResponsiblities = lazy(() =>
  import(
    './features/Setting/TransferResponsibilities/TransferResponsiblitiesContainer'
  ),
);


function App() {
  const dispatch = useDispatch();
  const isReadOnly = usePermission();
  const forceLoginPermission = useSelector(getForceLoginPermissionState);
  const isSmallScreen = useWindowSize();
  const [pageTitle, setPageTitle] = useState('');
  const [pageDescription, setPageDescription] = useState('');
  const location = useLocation();
  React.useEffect(() => {
    const activeRoute = find(routesWithMeta, { path: location.pathname });
    setPageTitle(
      (activeRoute?.meta?.title
        ? activeRoute?.meta?.title.charAt(0).toUpperCase() +
        activeRoute?.meta?.title.slice(1)
        : location.pathname?.split('/')?.pop()?.charAt(0).toUpperCase() +
        location.pathname?.split('/')?.pop()?.slice(1)) + ' - occy APP',
    );
    setPageDescription(activeRoute?.meta?.description);

  }, [location]);

  return (
    <Container
      fluid
      className={
        location?.pathname === '/' ||
        isPublicPage(location?.pathname) ||
        (isSmallScreen &&
          location?.pathname?.includes('video') &&
          location?.pathname?.includes('forms'))
          ? 'p-0'
          : undefined
      }
    >
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <ReleaseChannelBadge />

      <Routes>
        <Route path="oauth2/idpresponse" element={<GoogleComponentLogin />} />
        <Route
          path="oauth2/ms/idpresponse"
          element={<OutlookComponentLogin />}
        />
        {/* <Route path="/" element={<Login />} /> */}
        <Route
          path="api/calendar/outlook-callback-url"
          element={<OutlookComponent />}
        />
        <Route
          path="api/calendar/google-callback-url"
          element={<GoogleCalendar />}
        />
        <Route path="/_clear" element={<ClearStorage />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/force-login/" element={<ForceLogin />} />
        <Route path="/auth/cb" element={<LoginByCognito />} />
        <Route path="/" element={<LoginForm />} />





        {/* Public Routes */}

        <Route element={<PublicPagesTheme />}>
          <Route path="/forms/public" element={<PublicFormContainer />} />
          <Route path="forms/:id/preview" element={<FormPreview />} />
          <Route path="/components" element={<ComponentsList />} />
          <Route path="/p/interview/" element={<CandidateSelfSchedule />} />
          <Route path="/p/video-profile" element={<ProfileVideo />} />
          <Route path="/p/video-profile/job-details" element={<ProfileVideoJobDetails />} />
          <Route path="/p/ref-check" element={<AddRefereeForm />} />
          <Route path="/p/reference-check/add-referee" element={<AddReferee />} />


          <Route path="/p/job-offer" element={<JobOfferContainer />} />
          <Route path="/p/signable-preview" element={<SignablePreview />} />
          <Route
            path="/p/non-signable-preview"
            element={<NonPresignedOfferContainer />}
          />
          <Route
            path="/p/employment-agreement"
            element={<DocumentContainer />}
          />

          <Route path="/offer-letter/" element={<OfferLetter />} />
          <Route
            path="/kanban-offer-letter/"
            element={<KanbanOfferLetterContainer />}
          />
          <Route
            path="/p/unsubscribe/:token"
            element={<UnsubscribeContainer />}
          />
          <Route path="/privacy-policy/" element={<PrivacyPolicyContainer />} />
          <Route path="/policies/" element={<PolicyContainer />} />
          <Route path="/restricted" element={<RestrictedAccess />} />
          <Route path="/p/jobs/:companyId" element={<CareerPublicPreview />} />
          <Route path="/p/job/:publicId" element={<SearchPublicPage />} />
          <Route path="/welcome/" element={<WelcomePage />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard/*" element={<DashboardContainer />} />
          <Route
            path="/delegated/user/:id/*"
            element={<DelegetedUserLogin />}
          />
          <Route path="/activities" element={<Alerts />} />
          <Route path="/notifications/*" element={<ViewAllNotifications />} />
          <Route path="/settings/*" element={<UserRoutes />} />
          <Route
            element={
              <MidleWare
                allowedRoles={[USERROLES.ADMIN, USERROLES.RECRUITER]} 
                noBasicAllowed
              />
            }
          >
            {/* <Route path="/copywrite/*" element={<CopyrightListing />} /> */}
            <Route path="/schedule/reporting/*" element={<ReportingRoutes />} />
            <Route path="/analytics/:dashboardId?" element={<AnalyticsDashboard />} />
            {/* <Route path="/slots/*" element={<RecruitersRoutes />} /> */}
            <Route path="/offers-and-agreements/*" element={<OffersRoutes />} />
          </Route>

          <Route
            element={
              <MidleWare
                allowedRoles={[
                  USERROLES.ADMIN,
                  USERROLES.RECRUITER,
                  USERROLES.INTERVIEWER,
                  USERROLES.HIRINGMANAGER,
                ]}
              />
            }
          >
            <Route path="/jobs/*" element={<JobRoutes />} />
            <Route
              path="/authority-to-recruit/*"
              element={<AuthorityToRecruitRoutes />}
            />
          </Route>

          <Route
            element={
              <MidleWare
                allowedRoles={[
                  USERROLES.ADMIN,
                  USERROLES.RECRUITER,
                  USERROLES.INTERVIEWER,
                  USERROLES.HIRINGMANAGER,
                  USERROLES.BILLINGADMIN,
                ]}
              />
            }
          >
            <Route path="/wizard/*" element={<WizardRoutes />} />
            <Route path="/workflow/:tplId/*" element={<PipelineAutomation />} />
            <Route path="/calendar/*" element={<CalenderView />} />
            <Route
              path="/transfer-responsibilities/:teamMemberId/:process"
              element={<TransferResponsiblities />}
            />

            {/* <Route
            path="copywrite/:copywriteId/copywrite-information"
            element={<CopywriteDetailView />}
          /> */}
          </Route>
          <Route element={<MidleWare allowedRoles={[USERROLES.ADMIN]} />}>
            <Route
              path="/settings/company/career-site/*"
              element={<CareerPageContainer />}
            />
          </Route>
          <Route
            element={
              <MidleWare
                allowedRoles={[USERROLES.ADMIN, USERROLES.RECRUITER]}
                noBasicAllowed
              />
            }
          >
            <Route path="/mails/*" element={<MailRoutes />} />
          </Route>
          <Route
            element={
              <MidleWare
                allowedRoles={[
                  USERROLES.ADMIN,
                  USERROLES.RECRUITER,
                  USERROLES.HIRINGMANAGER,
                ]}
                noBasicAllowed
              />
            }
          >
            <Route path="/campaigns/*" element={<CampaignRoutes />} />
            <Route path="/candidates/*" element={<CandidateRoutes />} />
            <Route
              path="/candidate-pooling/*"
              element={<Navigate to="/candidates" replace />}
            />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <StyledToastContainer
        position="top-center"
        autoClose={1700}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <PermissionDeniedModal />
      {(isReadOnly?.permission?.payload || forceLoginPermission?.payload) && (
        <LimitedPermissionModal
          show={isReadOnly?.permission?.payload || forceLoginPermission?.payload}
          forceLoginPermission={forceLoginPermission?.payload}
          onHide={() => {
            dispatch(setOOOPermission(false));
            dispatch(setForceLoginPermission(false));
          }}
        />
      )}
    </Container>
  );
}
export default App;
